/* Quick-add modal + Glem-ikke-poser modal for Danmarks-Posen.
 *
 * Håndterer:
 *  - Quick-add modal: åbnes fra upsell-kort i kurven, AJAX-tilføjer variant+leveringsplan
 *  - Glem-ikke-poser modal: intercepter checkout hvis spand uden matchende pose findes
 *  - Free shipping nudge: live opdatering når valgt qty krydser fragt-grænsen
 *  - sessionStorage anti-nag: glem-ikke-modal fyrer kun én gang per session
 */
(function () {
  'use strict';

  var SESSION_KEY_FORGOT_BAGS = 'dp_forgot_bags_dismissed';
  /* Faelles minde for "glem ikke poser" og sidste chance (Magnus 29/9 2026: de skal
     foelge hinanden). Tidspunktet for kundens nej gemmes i localStorage, og begge holder
     pause i det antal dage temaet siger (standard 7, 0 = kun resten af besoeget). */
  var LOCAL_KEY_POSER_NEJ = 'dp_poser_nej_tid';
  function poserPauseDage() {
    var m = document.getElementById('forgot-bags-modal');
    var d = m ? parseFloat(m.getAttribute('data-poser-pause-dage')) : NaN;
    return isNaN(d) ? 1 : d;
  }
  /* Sidste chance har sin egen, laengere pause (Magnus 29/9 2026: en gang pr. 7 dage),
     talt fra den dag tilbuddet blev VIST. Paamindelsen kan altsaa komme igen dagen
     efter, uden at tilbuddet om rullen til 10 kr foelger med. */
  var LOCAL_KEY_SIDSTE_CHANCE = 'dp_sidste_chance_tid';
  function sidsteChancePauseAktiv() {
    var m = document.getElementById('forgot-bags-modal');
    var d = m ? parseFloat(m.getAttribute('data-sidste-chance-pause-dage')) : NaN;
    if (isNaN(d)) d = 7;
    if (!(d > 0)) return false;
    try {
      var t = parseInt(localStorage.getItem(LOCAL_KEY_SIDSTE_CHANCE), 10);
      if (t && (Date.now() - t) < d * 86400000) return true;
    } catch (err) {}
    return false;
  }
  /* Maaling (Magnus 29/9 2026: "gemmer vi stats paa hvordan det virker?"). En anonym
     taelling pr. trin til dashboardet: trinnet, posestoerrelsen og farven. Ingen cookie,
     intet id, ingen personoplysninger. sendBeacon blokerer aldrig kunden, og fejler den,
     sker der ingenting. */
  var MAALING_URL = 'https://dp.gezar.dk/haendelse/upsell';
  function maal(t, familieNoegle, farve) {
    try {
      var body = JSON.stringify({ t: t, f: familieNoegle || '', fa: farve || '' });
      if (navigator.sendBeacon) navigator.sendBeacon(MAALING_URL, new Blob([body], { type: 'text/plain' }));
    } catch (err) {}
  }
  function familieForBin(bin) {
    try {
      var d = hentSidsteChanceData();
      return (d && bin && d.spand_til_familie && d.spand_til_familie[bin.binHandle]) || '';
    } catch (err) { return ''; }
  }
  function chanceTrinVist() {
    var el = document.getElementById('forgot-bags-step-chance');
    return !!(el && !el.hidden);
  }
  function valgtFarveNavn() {
    var f = currentChanceFamilie;
    if (!f || !f.farver) return '';
    for (var i = 0; i < f.farver.length; i++) if (f.farver[i].id === currentChanceVariantId) return f.farver[i].navn;
    return '';
  }
  function poserNejAktiv() {
    try { if (sessionStorage.getItem(SESSION_KEY_FORGOT_BAGS) === 'true') return true; } catch (err) {}
    var dage = poserPauseDage();
    if (!(dage > 0)) return false;
    try {
      var t = parseInt(localStorage.getItem(LOCAL_KEY_POSER_NEJ), 10);
      if (t && (Date.now() - t) < dage * 86400000) return true;
    } catch (err) {}
    return false;
  }
  function saetPoserNej() {
    try { sessionStorage.setItem(SESSION_KEY_FORGOT_BAGS, 'true'); } catch (err) {}
    try { localStorage.setItem(LOCAL_KEY_POSER_NEJ, String(Date.now())); } catch (err) {}
  }
  var SESSION_KEY_SIDSTE_CHANCE = 'dp_sidste_chance_vist';
  var SIDSTE_CHANCE_TILBUDSPRIS_KR = 10;
  var lastTriggerElement = null;

  /* "Sidste chance": tilbud om én enkelt rulle når kunden siger nej til poserne.
     Sat af openForgotBagsModal() / maybeShowSidsteChance() nedenfor. */
  var currentBinData = null;
  var currentChanceFamilie = null;
  var currentChanceBin = null;
  var currentChanceVariantId = null;
  var sidsteChanceDataCache; /* undefined = ikke forsøgt hentet endnu */

  /* ---------- helpers ---------- */

  function getCartTotalCents() {
    return (window.dpCartData && typeof window.dpCartData.totalPrice === 'number')
      ? window.dpCartData.totalPrice
      : 0;
  }

  function getFreeShippingThresholdCents() {
    return (window.dpCartData && typeof window.dpCartData.shippingThreshold === 'number')
      ? window.dpCartData.shippingThreshold
      : 0;
  }

  function formatMoneyDkk(cents) {
    if (typeof cents !== 'number') return '';
    var kr = Math.round(cents / 100);
    return kr.toLocaleString('da-DK') + ' kr';
  }

  function refreshCartData() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dpCartData = window.dpCartData || {};
        window.dpCartData.totalPrice = cart.total_price;
        window.dpCartData.itemCount = cart.item_count;
        window.dpCartData.attributes = cart.attributes || {};
        return cart;
      })
      .catch(function () { /* tolerér fejl - vi har stadig stale data */ });
  }

  function lockBodyScroll() {
    document.documentElement.classList.add('no-scroll');
  }

  function unlockBodyScroll() {
    document.documentElement.classList.remove('no-scroll');
  }

  function dispatchCartRefresh() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  /* ---------- upsell-måling ----------
   * Vi kan ellers ikke se forskel på "solgt fra kurv-upsellet" og "solgt fra sin egen
   * produktside", og uden den forskel er vægtene i shop.metafields.upsell.vaegte
   * bygget på tal der ikke betyder noget.
   *
   * KURV-attributter, ikke line item properties. En properties[...] på en vare tvinger
   * Shopify til at oprette en SEPARAT kurv-linje for samme variant, så kunden ville se
   * klistermærkerne stå to gange. Attributter ligger på kurven som helhed, rører ikke
   * linjerne, og følger med i ordren som note_attributes.
   *
   * /cart/update.js FLETTER attributter, så temaets egne
   * (collection_mobile_items_per_row / collection_desktop_items_per_row) overlever.
   */

  var upsellSyncKoerer = false;
  var sidsteUpsellKlik = null;
  var froeSkrives = false;

  /* Rotationsfrø. Liquid har intet der varierer pr. kurv: cart.token, cart.id,
     cart.attributes, cart.note og line item keys er alle enten tomme eller ens for to
     kunder med samme vare (målt 19/8 2026). Kurv-attributter er den eneste kanal der
     både kan skrives fra browseren og læses server-side, så frøet lever der.
     Sættes ved FØRSTE sidebesøg, også med tom kurv, så det er på plads inden kunden
     overhovedet ser et upsell-kort - ellers ville den allerførste visning, som typisk
     er kurv-skuffen lige efter add-to-cart, være ens for alle. */
  function nytFroe() {
    var hex = '0123456789abcdef', ud = '';
    if (window.crypto && window.crypto.getRandomValues) {
      var buf = new Uint8Array(16);
      window.crypto.getRandomValues(buf);
      for (var i = 0; i < buf.length; i++) ud += hex[buf[i] & 15];
      return ud;
    }
    for (var j = 0; j < 16; j++) ud += hex[Math.floor(Math.random() * 16)];
    return ud;
  }

  function sikrUpsellFroe() {
    if (froeSkrives) return Promise.resolve();
    froeSkrives = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.upsell_froe) return null;
        return opdaterKurvAttribut('upsell_froe', nytFroe());
      })
      .then(function () { froeSkrives = false; })
      .catch(function () { froeSkrives = false; });
  }

  function opdaterKurvAttribut(navn, vaerdi) {
    var krop = { attributes: {} };
    krop.attributes[navn] = vaerdi;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(krop),
      credentials: 'same-origin'
    });
  }

  /* upsell_vist er foreningsmængden af ALT kurven har tilbudt, ikke sidste optegnings
     øjebliksbillede. Overskrev vi - som koden gjorde indtil 21/8 2026 - slettede vi
     netop den visning der førte til salget: et tilføjet produkt filtreres væk fra
     kandidaterne, og næste optegning skriver en liste uden det. Målt på de to første
     rigtige ordrer manglede to af tre tilføjelser deres visning, og kroner pr. visning
     var derfor overvurderet 14-25 % - kun for de produkter der sælger.

     PLADSEN ER FRA FØRSTE VISNING. Rotationen blander, så et produkt kan stå på plads 1
     i én optegning og plads 3 i den næste (målt). Vi beholder den første, fordi det er
     den kunden faktisk så først. Det er et valg: den nyeste ville måle et andet tal end
     det der drev klikket.

     LOFTET er 10 produkter. Ikke fordi /cart/update.js knækker: målt 21/8 2026 tog den
     60.000 tegn i én attribut med HTTP 200 og gemte dem hele. Men vejen videre - gennem
     checkout og ud i ordrens note_attributes - er ikke målt, og et felt uden loft har
     ingen øvre grænse overhovedet. Målingen må aldrig kunne vælte et køb, så den får en
     grænse den selv kender, i stedet for at læne sig op ad en vi ikke har efterprøvet.
     Ved loftet holder vi op med at tilføje NYE produkter; de første 10 bliver stående -
     samme begrundelse som pladsen: det tidlige er det vi måler på, og et felt der er
     holdt op med at vokse fyrer heller ingen flere kald. Konsekvens: i en meget lang
     session registreres senere produkter ikke som vist. Salget tælles stadig, fordi det
     bæres af upsell_tilfoejet, som er et andet felt uden dette loft. */
  var UPSELL_VIST_LOFT = 10;

  /* Flet gemt og nyt. Gemt kommer først, så en handle der allerede står, beholder sin
     plads. Returnerer en streng der ALTID har gemt som præfiks når intet er nyt - det er
     dét der gør streng-sammenligningen i synkUpsellVist til et gyldigt "ingen ændring". */
  function fletUpsellVist(gemt, nyt) {
    var ud = [], set = {};
    function tilfoej(post) {
      var handle = (post || '').split(':')[0];
      if (!handle || set[handle]) return;
      if (ud.length >= UPSELL_VIST_LOFT) return;
      set[handle] = true;
      ud.push(post);
    }
    (gemt ? gemt.split(',') : []).forEach(tilfoej);
    (nyt ? nyt.split(',') : []).forEach(tilfoej);
    return ud.join(',');
  }

  /* Synkroniser "hvilke kort blev vist" til kurven. Skriver KUN når foreningsmængden
     reelt vokser - ellers ville hver eneste kurv-optegning fyre et /cart/update.js og
     kappes med de øvrige kurv-kald om den samme kurv. */
  function synkUpsellVist() {
    if (upsellSyncKoerer || isAdding) return Promise.resolve();
    var panel = document.querySelector('[data-upsell-vist]');
    var vist = panel ? (panel.getAttribute('data-upsell-vist') || '') : '';
    if (!vist) return Promise.resolve();
    upsellSyncKoerer = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nuvaerende = (cart.attributes && cart.attributes.upsell_vist) || '';
        var flettet = fletUpsellVist(nuvaerende, vist);
        if (nuvaerende === flettet) return null;
        return opdaterKurvAttribut('upsell_vist', flettet);
      })
      .then(function () { upsellSyncKoerer = false; })
      .catch(function () { upsellSyncKoerer = false; });
  }

  /* Kaldes efter en gennemført add. sidsteUpsellKlik er kun sat hvis knappen bar
     data-upsell-plads, dvs. hvis klikket kom fra et "Andre har også købt"-kort -
     ikke fra produktsiden og ikke fra "Poser passer til". */
  function registrerUpsellTilfoejet() {
    var klik = sidsteUpsellKlik;
    sidsteUpsellKlik = null;
    if (!klik) return Promise.resolve();
    var post = klik.handle + ':' + klik.plads;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nuvaerende = (cart.attributes && cart.attributes.upsell_tilfoejet) || '';
        var dele = nuvaerende ? nuvaerende.split(',') : [];
        if (dele.indexOf(post) !== -1) return null;
        dele.push(post);
        return opdaterKurvAttribut('upsell_tilfoejet', dele.join(','));
      })
      .catch(function () { /* måling må aldrig vælte et køb */ });
  }

  /* Pop-up 1 ("Glem ikke poser"): variant-id'erne kunden lagde i kurven fra popuppen.
     Foreningsmængde (læs, tilføj, skriv), aldrig overskrivning. Kurv-attribut, ikke line
     item property (se ovenfor). Skal være skrevet FØR flowet går videre mod kassen. */
  function registrerGlemPoserTilfoejet(ids) {
    if (!ids || !ids.length) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nuvaerende = (cart.attributes && cart.attributes.glem_poser_tilfoejet) || '';
        var dele = nuvaerende ? nuvaerende.split(',') : [];
        var nyt = false;
        ids.forEach(function (id) {
          id = String(id);
          if (dele.indexOf(id) === -1) { dele.push(id); nyt = true; }
        });
        if (!nyt) return null;
        return opdaterKurvAttribut('glem_poser_tilfoejet', dele.join(','));
      })
      .catch(function () { /* måling må aldrig vælte et køb */ });
  }

  /* Luk uden ja eller nej (kryds, klik på baggrund, Esc): glem_luk på pop-up 1,
     sc_luk på pop-up 2. */
  function maalLuk() {
    if (chanceTrinVist()) maal('sc_luk', familieForBin(currentChanceBin), valgtFarveNavn());
    else maal('glem_luk', familieForBin(currentBinData));
  }

  /* ---------- quick-add modal ---------- */

  /* Group-modal (poser_til_2): load det valgte formats produkt-template ind i
     [data-qa-format-body]. Erstatter eksisterende body, så kun ÉT format (én .QuickAdd)
     er aktivt ad gangen - alle add/nudge-funktioner querier derfor det rigtige produkt. */
  function maybeLoadFormatBody(content) {
    var body = content.querySelector('[data-qa-format-body]');
    if (!body) return;
    var radio = content.querySelector('input[data-format-handle]:checked') ||
                content.querySelector('input[data-format-handle]');
    if (!radio) return;
    /* Husk valgt leveringstype FOER body udskiftes, saa format-skift ikke nulstiller til enkeltkøb */
    var prevMode = getSelectedMode(content);
    var fh = radio.getAttribute('data-format-handle');
    var tmpl = document.getElementById('quick-add-template-' + fh);
    body.innerHTML = '';
    if (tmpl) {
      body.appendChild(tmpl.content.cloneNode(true));
    } else {
      console.warn('[dp-quick-add] format-template missing for handle:', fh);
    }
    /* Genskab leveringsplan-valg paa den nye body (ellers springer den tilbage til enkeltkøb) */
    if (prevMode === 'plan') {
      var planRadio = body.querySelector('input[name^="qa-mode-"][value="plan"]');
      if (planRadio) {
        planRadio.checked = true;
        var planWrap = body.querySelector('[data-qa-plan-interval]');
        if (planWrap) planWrap.style.display = '';
      }
    }
    /* Opdater priser (variant + fliser) og hjaelpe-linje ift. valgt leveringstype */
    updateVariantPrices(content);
  }

  function openQuickAddModal(productHandle, triggerEl) {
    var modal = document.getElementById('quick-add-modal');
    var content = document.getElementById('quick-add-modal-content');
    if (!modal || !content) return;

    var template = document.getElementById('quick-add-template-' + productHandle);
    if (!template) {
      console.warn('[dp-quick-add] template missing for handle:', productHandle);
      return;
    }

    /* Render template-indhold */
    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));

    /* Group-modal (poser_til_2): load default-formatets body ind i placeholder */
    maybeLoadFormatBody(content);
    /* Enkelt-produkt (ingen format-body): sikr korrekt pris-visning ift. leveringstype */
    updateVariantPrices(content);

    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    lastTriggerElement = triggerEl || null;

    /* Focus første interaktive element */
    setTimeout(function () {
      var focusable = modal.querySelector('.QuickAddModal__Close');
      if (focusable) focusable.focus();
    }, 50);

    /* Init add-knap state + free shipping nudge.
       Refresh cart-data i baggrunden så nudgen er korrekt selv hvis dpCartData er stale. */
    updateAddButtonState(content);
    updateShippingNudge(content);
    refreshCartData().then(function () { updateShippingNudge(content); });
  }

  function closeQuickAddModal() {
    var modal = document.getElementById('quick-add-modal');
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    var content = document.getElementById('quick-add-modal-content');
    if (content) content.innerHTML = '';
    unlockBodyScroll();

    if (lastTriggerElement && typeof lastTriggerElement.focus === 'function') {
      lastTriggerElement.focus();
    }
    lastTriggerElement = null;
  }

  /* ---------- variant qty + add-state ---------- */

  function updateAddButtonState(container) {
    var inputs = container.querySelectorAll('.QuickAdd__QtyInput');
    var total = 0;
    inputs.forEach(function (inp) {
      total += parseInt(inp.value, 10) || 0;
    });
    var btn = container.querySelector('[data-action="qa-add-to-cart"]');
    var note = container.querySelector('[data-qa-note]');
    if (btn) btn.disabled = total === 0;
    if (note) note.style.display = total === 0 ? '' : 'none';
  }

  /* Skift variant-priser mellem enkeltkøb og leveringsplan (10% rabat).
     Begge priser er pre-renderet af Liquid (money-format er korrekt) - vi toggler kun synlighed. */
  function updateVariantPrices(container) {
    if (!container) return;
    var isPlan = getSelectedMode(container) === 'plan';
    /* Variant-priser i body */
    container.querySelectorAll('.QuickAdd__Variant').forEach(function (card) {
      var one = card.querySelector('.QuickAdd__VariantPrice--onetime');
      var plan = card.querySelector('.QuickAdd__VariantPrice--plan');
      if (plan) { plan.hidden = !isPlan; if (one) one.hidden = isPlan; }
      else if (one) { one.hidden = false; }
    });
    /* Flise-priser i toppen (antal-ruller-fliserne) */
    container.querySelectorAll('.QuickAdd__FormatTile').forEach(function (tile) {
      var one = tile.querySelector('.QuickAdd__TilePrice--onetime');
      var plan = tile.querySelector('.QuickAdd__TilePrice--plan');
      if (plan) { plan.hidden = !isPlan; if (one) one.hidden = isPlan; }
      else if (one) { one.hidden = false; }
    });
    /* Hjaelpe-linje: valgt formats detalje med korrekt leveringstype-pris pr. pose */
    var helper = container.querySelector('[data-qa-format-helper]');
    if (helper) {
      var checkedFmt = container.querySelector('input[data-format-handle]:checked') ||
                       container.querySelector('input[data-format-handle]');
      if (checkedFmt) {
        var h = isPlan ? (checkedFmt.getAttribute('data-fmt-helper-plan') || checkedFmt.getAttribute('data-fmt-helper'))
                       : checkedFmt.getAttribute('data-fmt-helper');
        helper.textContent = h || '';
      }
    }
  }

  function getSelectedMode(container) {
    var qa = container.querySelector('.QuickAdd');
    if (!qa) return 'onetime';
    var productId = qa.getAttribute('data-product-id');
    var checked = container.querySelector('input[name="qa-mode-' + productId + '"]:checked');
    return checked ? (checked.value || 'onetime') : 'onetime';
  }

  /* Returner discount-faktor baseret på leveringsplan-mode.
   * Når kunden vælger "Leveringsplan (spar 10%)" giver Shopify 10% rabat på linjeprisen.
   * Nudgen skal regne med den rabatterede pris, ellers over-lover vi gratis fragt. */
  function getModeDiscountMultiplier(container) {
    var mode = getSelectedMode(container);
    return mode === 'plan' ? 0.9 : 1.0;
  }

  function updateShippingNudge(container) {
    var nudgeBox = container.querySelector('[data-shipping-nudge]');
    var nudgeText = container.querySelector('.QuickAdd__ShippingNudgeText');
    if (!nudgeBox || !nudgeText) return;

    var threshold = getFreeShippingThresholdCents();
    if (threshold <= 0) {
      nudgeBox.style.display = 'none';
      return;
    }

    var currentCartCents = getCartTotalCents();
    if (typeof currentCartCents !== 'number' || currentCartCents < 0) currentCartCents = 0;

    var discountMultiplier = getModeDiscountMultiplier(container);
    var addedCents = 0;
    container.querySelectorAll('.QuickAdd__Variant').forEach(function (card) {
      var input = card.querySelector('.QuickAdd__QtyInput');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      var price = parseInt(card.getAttribute('data-variant-price'), 10) || 0;
      if (qty > 0 && price > 0) addedCents += qty * price;
    });
    addedCents = Math.round(addedCents * discountMultiplier);

    var newTotal = currentCartCents + addedCents;
    var cartAlreadyQualifies = currentCartCents >= threshold;
    var addingCrossesThreshold = !cartAlreadyQualifies && addedCents > 0 && newTotal >= threshold;

    /* Nudgen er altid synlig - viser kurvens NUVÆRENDE tilstand ved antal=0,
       konsekvensen ved antal>=1. Aldrig "Du har fri fragt på poser" hvis kurven ikke
       allerede kvalificerer. */
    nudgeBox.style.display = '';
    if (cartAlreadyQualifies) {
      nudgeBox.classList.add('QuickAdd__ShippingNudge--achieved');
      nudgeText.textContent = 'Du har fri fragt på poser';
    } else if (addingCrossesThreshold) {
      nudgeBox.classList.add('QuickAdd__ShippingNudge--achieved');
      nudgeText.textContent = 'Du får fri fragt på poser';
    } else {
      nudgeBox.classList.remove('QuickAdd__ShippingNudge--achieved');
      var remaining = threshold - newTotal;
      nudgeText.textContent = 'Brug ' + formatMoneyDkk(remaining) + ' mere og få fri fragt på poser';
    }
  }

  function getSelectedSellingPlan(container) {
    var qa = container.querySelector('.QuickAdd');
    if (!qa) return null;
    var mode = getSelectedMode(container);
    if (mode !== 'plan') return null;
    var productId = qa.getAttribute('data-product-id');
    var select = container.querySelector('select[name="qa-selling-plan-' + productId + '"]');
    if (!select || !select.value || select.value === '' || select.value === '0') return null;
    return parseInt(select.value, 10);
  }

  function collectItems(container) {
    var sellingPlan = getSelectedSellingPlan(container);
    var items = [];
    container.querySelectorAll('.QuickAdd__Variant').forEach(function (card) {
      var input = card.querySelector('.QuickAdd__QtyInput');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      if (qty > 0) {
        var item = {
          id: parseInt(card.getAttribute('data-variant-id'), 10),
          quantity: qty
        };
        if (sellingPlan) item.selling_plan = sellingPlan;
        items.push(item);
      }
    });
    return items;
  }

  /* ---------- AJAX add ---------- */

  var isAdding = false;

  function quickAddSubmit(container, opts) {
    if (isAdding) return Promise.resolve(false);
    var items = collectItems(container);
    if (items.length === 0) return Promise.resolve(false);

    isAdding = true;
    var btn = container.querySelector('[data-action="qa-add-to-cart"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Tilføjer...'; }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function () {
        return registrerUpsellTilfoejet();
      })
      .then(function () {
        if (opts && opts.glemPoser) return registrerGlemPoserTilfoejet(items.map(function (i) { return i.id; }));
      })
      .then(function () {
        return refreshCartData();
      })
      .then(function () {
        dispatchCartRefresh();
        isAdding = false;
        if (btn) { btn.textContent = origText; }
        if (opts && opts.thenSubmitForm && opts.formEl) {
          /* For glem-ikke-poser: efter add fortsætter vi til checkout */
          setTimeout(function () {
            window.removeEventListener('beforeunload', noop);
            opts.formEl.removeEventListener('submit', forgotBagsCheckoutInterceptor, true);
            opts.formEl.submit();
          }, 400);
        } else {
          closeQuickAddModal();
          closeForgotBagsModal();
        }
        return true;
      })
      .catch(function (err) {
        console.error('[dp-quick-add] add failed:', err);
        isAdding = false;
        if (btn) { btn.disabled = false; btn.textContent = origText; }
        alert('Kunne ikke tilføje til kurv. Prøv igen.');
        return false;
      });
  }

  function noop() {}

  /* ---------- glem-ikke-poser modal ---------- */

  function getUncoveredBins() {
    var bins = [];
    document.querySelectorAll('[data-uncovered-bin]').forEach(function (el) {
      bins.push({
        binTitle: el.getAttribute('data-bin-title') || '',
        binHandle: el.getAttribute('data-bin-handle') || '',
        binFarve: el.getAttribute('data-bin-farve') || '',
        poseHandle: el.getAttribute('data-pose-handle') || '',
        poseTitle: el.getAttribute('data-pose-title') || ''
      });
    });
    return bins;
  }

  function openForgotBagsModal(bin) {
    var modal = document.getElementById('forgot-bags-modal');
    if (!modal) return false;

    currentBinData = bin;

    var target = document.getElementById('forgot-bags-quick-add-target');
    var template = document.getElementById('quick-add-template-' + bin.poseHandle);
    if (!target || !template) {
      console.warn('[dp-forgot-bags] template missing for handle:', bin.poseHandle);
      return false;
    }

    /* Indsæt quick-add-template i modal */
    target.innerHTML = '';
    target.appendChild(template.content.cloneNode(true));

    /* Group-template (poser_til_2): load default-formatets body ind i placeholder */
    maybeLoadFormatBody(target);
    updateVariantPrices(target);

    /* Opdater spand-navn i lead-tekst */
    var binTitleEls = modal.querySelectorAll('[data-fb-bin-title]');
    binTitleEls.forEach(function (el) { el.textContent = bin.binTitle; });

    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();

    setTimeout(function () {
      var focusable = modal.querySelector('.ForgotBagsModal__Close');
      if (focusable) focusable.focus();
    }, 50);

    updateAddButtonState(target);
    updateShippingNudge(target);
    return true;
  }

  function closeForgotBagsModal() {
    var modal = document.getElementById('forgot-bags-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    var target = document.getElementById('forgot-bags-quick-add-target');
    if (target) target.innerHTML = '';
    unlockBodyScroll();
    resetSidsteChanceTrin();
  }

  /* ---------- "sidste chance": én rulle til rabatkode når poserne bliver fravalgt ----------
   * Vises i STEDET for at gå direkte til checkout, når kunden trykker "Nej tak" eller X i
   * glem-ikke-poser modalen. Kun når settings.sidste_chance_aktiv er slået til, kun én gang
   * pr. session, og kun når spanden har en kendt rulle-familie (sidste-chance-mapping.liquid).
   */

  function hentSidsteChanceData() {
    if (sidsteChanceDataCache !== undefined) return sidsteChanceDataCache;
    var el = document.getElementById('sidste-chance-data');
    if (!el) { sidsteChanceDataCache = null; return null; }
    try {
      sidsteChanceDataCache = JSON.parse(el.textContent);
    } catch (err) {
      console.warn('[dp-sidste-chance] kunne ikke læse mapping:', err);
      sidsteChanceDataCache = null;
    }
    return sidsteChanceDataCache;
  }

  function findVariantIdForFarve(familie, spandFarve) {
    if (!familie.farve_variant_id) return familie.standard_variant_id;
    var oversaet = { 'sølv': 'solv', 'grøn': 'groen' };
    var noegle = (spandFarve || '').toLowerCase();
    noegle = oversaet[noegle] || noegle;
    if (familie.farve_variant_id[noegle]) return familie.farve_variant_id[noegle];
    return familie.standard_variant_id;
  }

  function resetSidsteChanceTrin() {
    var stepPoser = document.getElementById('forgot-bags-step-poser');
    var footerPoser = document.getElementById('forgot-bags-footer-poser');
    var stepChance = document.getElementById('forgot-bags-step-chance');
    var footerChance = document.getElementById('forgot-bags-footer-chance');
    if (stepPoser) stepPoser.hidden = false;
    if (footerPoser) footerPoser.hidden = false;
    if (stepChance) stepChance.hidden = true;
    if (footerChance) footerChance.hidden = true;
  }

  function visSidsteChanceTrin(bin, familie) {
    try { sessionStorage.setItem(SESSION_KEY_SIDSTE_CHANCE, 'true'); }
    catch (err) { /* tolerér */ }
    try { localStorage.setItem(LOCAL_KEY_SIDSTE_CHANCE, String(Date.now())); } catch (err) {}

    currentChanceBin = bin;
    currentChanceFamilie = familie;
    maal('sc_vist', familieForBin(bin));

    /* "Clara-Clean - 3x18L skraldespand" -> "Clara-Clean" */
    var kortNavn = String(bin.binTitle || '').split(' - ')[0].trim() || bin.binTitle;
    document.querySelectorAll('[data-sc-bin-title]').forEach(function (el) {
      el.textContent = kortNavn;
    });
    /* Tilbudsprisen er FAST 10 kr: rabatkoderne PROEVE-* giver rullepris minus 10 kr.
       familie.pris_kr er NORMALPRISEN og maa kun vises som "normalt X kr". */
    var prisEl = document.querySelector('[data-sc-pris]');
    if (prisEl) prisEl.textContent = SIDSTE_CHANCE_TILBUDSPRIS_KR + ' kr';
    var normalEl = document.querySelector('[data-sc-normal]');
    if (normalEl) normalEl.textContent = familie.pris_kr ? ' (normalt ' + familie.pris_kr + ' kr)' : '';
    var imgEl = document.querySelector('[data-sc-billede]');
    if (imgEl) {
      imgEl.src = familie.billede || '';
      imgEl.alt = familie.label + ' affaldsposer, 1 rulle';
    }
    /* Farvevalg (Magnus 29/9 2026: "kan man vaelge farve paa rullen?"). Rabatkoderne
       gaelder alle farver af rullen. Forvalgt: spandens farve hvis rullen findes i den,
       ellers den foerste (sort). En rulle i kun én farve viser ingen knapper. */
    currentChanceVariantId = findVariantIdForFarve(familie, bin && bin.binFarve);
    var farveBox = document.querySelector('[data-sc-farver]');
    if (farveBox) {
      farveBox.innerHTML = '';
      var farver = familie.farver || [];
      farveBox.hidden = farver.length < 2;
      farver.forEach(function (f) {
        var knap = document.createElement('button');
        knap.type = 'button';
        knap.className = 'ForgotBagsModal__FarveBtn';
        knap.setAttribute('role', 'radio');
        knap.setAttribute('aria-checked', String(f.id === currentChanceVariantId));
        knap.textContent = f.navn;
        knap.addEventListener('click', function () {
          currentChanceVariantId = f.id;
          farveBox.querySelectorAll('.ForgotBagsModal__FarveBtn').forEach(function (k) { k.setAttribute('aria-checked', 'false'); });
          knap.setAttribute('aria-checked', 'true');
          if (imgEl && f.billede) { imgEl.src = f.billede; imgEl.alt = familie.label + ' affaldsposer, ' + f.navn.toLowerCase() + ', 1 rulle'; }
        });
        farveBox.appendChild(knap);
        if (f.id === currentChanceVariantId && imgEl && f.billede) imgEl.src = f.billede;
      });
    }

    var stepPoser = document.getElementById('forgot-bags-step-poser');
    var footerPoser = document.getElementById('forgot-bags-footer-poser');
    var stepChance = document.getElementById('forgot-bags-step-chance');
    var footerChance = document.getElementById('forgot-bags-footer-chance');
    if (stepPoser) stepPoser.hidden = true;
    if (footerPoser) footerPoser.hidden = true;
    if (stepChance) stepChance.hidden = false;
    if (footerChance) footerChance.hidden = false;
  }

  /* Returnerer true hvis sidste-chance-trinnet blev vist (kald skal IKKE fortsætte til
     checkout endnu), false hvis kaldet skal opføre sig som før (luk + fortsæt). */
  function maybeShowSidsteChance() {
    var modal = document.getElementById('forgot-bags-modal');
    if (!modal) return false;
    if (modal.getAttribute('data-sidste-chance-aktiv') !== 'true') return false;

    try {
      if (sessionStorage.getItem(SESSION_KEY_SIDSTE_CHANCE) === 'true') return false;
    } catch (err) { /* tolerér, viser da ikke trinnet igen sikkert, men fejler ikke */ }
    if (sidsteChancePauseAktiv()) return false;

    var bin = currentBinData;
    if (!bin || !bin.binHandle) return false;

    var data = hentSidsteChanceData();
    if (!data) return false;

    var familieNoegle = data.spand_til_familie[bin.binHandle];
    if (!familieNoegle) return false;

    var familie = data.familier[familieNoegle];
    if (!familie) return false;

    visSidsteChanceTrin(bin, familie);
    return true;
  }

  function finishSidsteChanceCheckout() {
    closeForgotBagsModal();
    var form = window.dpPendingCheckoutForm;
    if (form) {
      form.removeEventListener('submit', forgotBagsCheckoutInterceptor, true);
      form.submit();
      window.dpPendingCheckoutForm = null;
    } else {
      window.location.href = '/checkout';
    }
  }

  function addSidsteChanceRulleOgFortsaet(btn) {
    var familie = currentChanceFamilie;
    var bin = currentChanceBin;
    if (!familie) { finishSidsteChanceCheckout(); return; }

    if (btn) { btn.disabled = true; btn.textContent = 'Tilføjer...'; }

    var variantId = currentChanceVariantId || findVariantIdForFarve(familie, bin && bin.binFarve);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (err) { throw err; }); }
        return res.json();
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: familie.rabatkode }),
          credentials: 'same-origin'
        });
      })
      .then(function () {
        finishSidsteChanceCheckout();
      })
      .catch(function (err) {
        /* Et kald der fejler skal ikke låse kunden fast i modalen */
        console.error('[dp-sidste-chance] tilføjelse af rulle fejlede:', err);
        finishSidsteChanceCheckout();
      });
  }

  /* Intercept checkout-form submission */
  function forgotBagsCheckoutInterceptor(e) {
    var form = e.currentTarget;

    /* Hvis allerede afvist denne session: lad submit fortsætte */
    try {
      if (poserNejAktiv()) return;
    } catch (err) { /* sessionStorage kan fejle i private mode */ }

    var bins = getUncoveredBins();
    if (bins.length === 0) return; /* intet at nudge om */

    e.preventDefault();
    e.stopPropagation();

    /* Vis modal med første udækket spand */
    var opened = openForgotBagsModal(bins[0]);
    if (opened) maal('glem_vist', familieForBin(bins[0]));
    if (!opened) {
      /* Fallback: kunne ikke åbne modal, lad checkout fortsætte */
      form.removeEventListener('submit', forgotBagsCheckoutInterceptor, true);
      form.submit();
      return;
    }

    /* Stash form-referencen så "Tilføj og fortsæt" kan submitte den senere */
    window.dpPendingCheckoutForm = form;
  }

  function attachCheckoutInterceptors() {
    document.querySelectorAll('form[action="/checkout"]').forEach(function (form) {
      /* Undgå dobbelt-bind */
      if (form.__dpInterceptorAttached) return;
      form.__dpInterceptorAttached = true;
      form.addEventListener('submit', forgotBagsCheckoutInterceptor, true);
    });
  }

  function dismissForgotBagsAndContinue() {
    try { saetPoserNej(); }
    catch (err) { /* tolerér */ }

    /* Vis "sidste chance"-trinnet i stedet for at fortsætte direkte, hvis det er relevant.
       maybeShowSidsteChance() returnerer true når trinnet blev vist: kaldet stopper her og
       venter på klik på "Lad mig prøve poserne" eller "Nej tak, gå til betaling". */
    if (maybeShowSidsteChance()) return;

    closeForgotBagsModal();

    var form = window.dpPendingCheckoutForm;
    if (form) {
      form.removeEventListener('submit', forgotBagsCheckoutInterceptor, true);
      form.submit();
      window.dpPendingCheckoutForm = null;
    }
  }

  function dismissForgotBagsNoCheckout() {
    /* Brug ved overlay-klik / X / Escape: luk modal, sæt session-flag, lad kunden være.
       Viser "sidste chance"-trinnet på samme måde som "Nej tak, fortsæt uden poser",
       hvis det er relevant (se dismissForgotBagsAndContinue). */
    try { saetPoserNej(); }
    catch (err) { /* tolerér */ }

    if (maybeShowSidsteChance()) return;

    closeForgotBagsModal();
    window.dpPendingCheckoutForm = null;
  }

  /* ---------- event delegation ---------- */

  document.addEventListener('click', function (e) {
    /* Åbn quick-add modal */
    var opener = e.target.closest('[data-action="qa-open"]');
    if (opener) {
      e.preventDefault();
      var handle = opener.getAttribute('data-product-handle');
      /* Kun klik fra et upsell-kort bærer data-upsell-plads. Alle andre qa-open-klik
         (produktside, "Poser passer til") nulstiller, så de ikke tælles med. */
      var plads = opener.getAttribute('data-upsell-plads');
      sidsteUpsellKlik = (handle && plads) ? { handle: handle, plads: plads } : null;
      if (handle) openQuickAddModal(handle, opener);
      return;
    }

    /* Luk quick-add modal */
    if (e.target.closest('[data-action="qa-close"]')) {
      e.preventDefault();
      closeQuickAddModal();
      return;
    }

    /* Quick-add qty +/- */
    var qtyBtn = e.target.closest('[data-action="qa-qty-plus"], [data-action="qa-qty-minus"]');
    if (qtyBtn) {
      var card = qtyBtn.closest('.QuickAdd__Variant');
      var input = card ? card.querySelector('.QuickAdd__QtyInput') : null;
      if (input && !input.disabled) {
        var val = parseInt(input.value, 10) || 0;
        if (qtyBtn.getAttribute('data-action') === 'qa-qty-plus') {
          input.value = val + 1;
        } else {
          input.value = Math.max(0, val - 1);
        }
        var container = qtyBtn.closest('.QuickAdd').parentNode;
        updateAddButtonState(container);
        updateShippingNudge(container);
      }
      return;
    }

    /* Quick-add tilføj til kurv */
    if (e.target.closest('[data-action="qa-add-to-cart"]')) {
      e.preventDefault();
      var qaContainer = e.target.closest('#quick-add-modal-content, #forgot-bags-quick-add-target');
      if (qaContainer) {
        /* Hvis vi er i forgot-bags-flow, vil vi efter add også submitte checkout-form */
        var pendingForm = window.dpPendingCheckoutForm;
        if (qaContainer.id === 'forgot-bags-quick-add-target') maal('glem_tilfoej', familieForBin(currentBinData));
        if (qaContainer.id === 'forgot-bags-quick-add-target' && pendingForm) {
          quickAddSubmit(qaContainer, { thenSubmitForm: true, formEl: pendingForm, glemPoser: true });
        } else {
          quickAddSubmit(qaContainer, qaContainer.id === 'forgot-bags-quick-add-target' ? { glemPoser: true } : undefined);
        }
      }
      return;
    }

    /* Glem-ikke-poser: skip og checkout */
    if (e.target.closest('[data-action="fb-skip-and-checkout"]')) {
      e.preventDefault();
      maal('glem_nej', familieForBin(currentBinData));
      dismissForgotBagsAndContinue();
      return;
    }

    /* Glem-ikke-poser: dismiss uden checkout (overlay/X-knap) */
    if (e.target.closest('[data-action="fb-dismiss"]')) {
      e.preventDefault();
      /* X eller klik udenfor er en luk, ikke et nej (T-194) */
      maalLuk();
      dismissForgotBagsNoCheckout();
      return;
    }

    /* Sidste chance: tilføj enkeltrulle + rabatkode, fortsæt til checkout */
    var scAddBtn = e.target.closest('[data-action="sc-add-and-checkout"]');
    if (scAddBtn) {
      e.preventDefault();
      maal('sc_ja', familieForBin(currentChanceBin), valgtFarveNavn());
      addSidsteChanceRulleOgFortsaet(scAddBtn);
      return;
    }

    /* Sidste chance: nej tak, gå direkte til betaling uden rulle */
    if (e.target.closest('[data-action="sc-skip-and-checkout"]')) {
      e.preventDefault();
      maal('sc_nej', familieForBin(currentChanceBin), valgtFarveNavn());
      finishSidsteChanceCheckout();
      return;
    }
  });

  /* Input-event for qty (når brugeren skriver direkte) */
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('QuickAdd__QtyInput')) {
      var v = parseInt(e.target.value, 10);
      if (isNaN(v) || v < 0) e.target.value = 0;
      var container = e.target.closest('#quick-add-modal-content, #forgot-bags-quick-add-target');
      if (container) {
        updateAddButtonState(container);
        updateShippingNudge(container);
      }
    }
  });

  /* Mode-radio change: toggle plan-dropdown, recompute nudge */
  document.addEventListener('change', function (e) {
    /* Format-radio (koebsmulighed: kasse/3-pak/enkelt) change: load valgt formats body */
    if (e.target.matches && e.target.matches('input[data-format-handle]')) {
      var fmtContainer = e.target.closest('#quick-add-modal-content, #forgot-bags-quick-add-target');
      if (!fmtContainer) return;
      maybeLoadFormatBody(fmtContainer);
      updateAddButtonState(fmtContainer);
      updateShippingNudge(fmtContainer);
      return;
    }
    if (e.target.name && e.target.name.indexOf('qa-mode-') === 0) {
      var container = e.target.closest('#quick-add-modal-content, #forgot-bags-quick-add-target');
      if (!container) return;
      var planWrap = container.querySelector('[data-qa-plan-interval]');
      if (planWrap) {
        planWrap.style.display = e.target.value === 'plan' ? '' : 'none';
      }
      updateVariantPrices(container);
      updateShippingNudge(container);
      return;
    }
    /* Plan interval-select change: recompute nudge (rabat-multiplier uændret, men i fald
       fremtidige planer har andre rabatter end 10% kan logikken udvides her). */
    if (e.target.name && e.target.name.indexOf('qa-selling-plan-') === 0) {
      var container2 = e.target.closest('#quick-add-modal-content, #forgot-bags-quick-add-target');
      if (container2) updateShippingNudge(container2);
    }
  });

  /* Escape lukker modals */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var qaModal = document.getElementById('quick-add-modal');
    if (qaModal && qaModal.getAttribute('aria-hidden') === 'false') {
      closeQuickAddModal();
      return;
    }
    var fbModal = document.getElementById('forgot-bags-modal');
    if (fbModal && fbModal.getAttribute('aria-hidden') === 'false') {
      maalLuk();
      dismissForgotBagsNoCheckout();
    }
  });

  /* ---------- tom-kurv recommendations loader ----------
   * Henter 2 produkter til tom-kurv-area:
   *   - Primær: recently-viewed fra localStorage 'recentlyViewedProducts'
   *     (samme key som produktsidens system, sat af theme.js)
   *   - Fallback (ingen historik): hardcoded fallback-handles
   *     (Magnus kan udskifte i samme fil)
   *
   * Fetcher /search?view=cart-recs&type=product&q=... der renderer UpsellCard-markup
   * SERVER-SIDE via templates/search.cart-recs.liquid. JS inject'er HTML direkte -
   * ingen client-side parsing af billede/titel/pris (fixer brudt render fra 2r).
   */
  var DP_FALLBACK_HANDLES = ['mini-posen', 'small-lang-affaldsposer', 'affaldsposer-small-26l', 'klistermaerker-til-affaldssortering'];

  /* In-flight fetch tracking: undgår double-injection ved race conditions
     (page-load fetch + observer-trigget fetch begge inject'er deres response). */
  var dpRecAbortController = null;
  var dpRecLoading = false;

  function clearEmptyCartCards(recArea) {
    /* Behold h3 (label), fjern ALLE andre børn (UpsellCards + quick-add-templates).
       Bruges både i reset OG defensivt før hver injection (race-safety). */
    Array.from(recArea.children).forEach(function (c) {
      if (c.tagName !== 'H3') c.remove();
    });
  }

  function resetEmptyCartRecentlyViewed() {
    var recArea = document.querySelector('#sidebar-cart [data-empty-recently-viewed]');
    if (!recArea) return;
    /* Abort eventuel in-flight fetch så dens response IKKE inject'er */
    if (dpRecAbortController) {
      try { dpRecAbortController.abort(); } catch (e) {}
      dpRecAbortController = null;
    }
    dpRecLoading = false;
    recArea.__dpLoaded = false;
    clearEmptyCartCards(recArea);
    recArea.style.display = 'none';
  }

  function loadEmptyCartRecentlyViewed() {
    var recArea = document.querySelector('#sidebar-cart [data-empty-recently-viewed]');
    var labelEl = recArea ? recArea.querySelector('[data-empty-rec-label]') : null;
    if (!recArea) return;
    /* Lock: concurrent calls (observer + cart:refresh begge fyrer) returnerer */
    if (dpRecLoading) return;
    if (recArea.__dpLoaded) return;

    dpRecLoading = true;
    recArea.__dpLoaded = true;

    /* Læs FRISK localStorage på hvert load - aldrig cached snapshot */
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); }
    catch (e) { ids = []; }

    var isRecent = Array.isArray(ids) && ids.length > 0;
    var queryTokens;
    if (isRecent) {
      /* KUN top-2 nyeste - Shopify search returnerer IKKE i query-rækkefølge,
         så hvis vi spørger om alle 8 IDs vil Shopify returnere 2 vilkårlige
         (men konsistente) produkter baseret på sin egen ranking. Top-2 only
         tvinger Shopify til at returnere PRÆCIS de 2 nyeste-set IDs. */
      queryTokens = ids.slice(0, 2).map(function (id) { return 'id:' + id; });
    } else {
      queryTokens = DP_FALLBACK_HANDLES.map(function (h) { return 'handle:' + h; });
    }
    var query = queryTokens.join(' OR ');

    dpRecAbortController = new AbortController();
    var thisController = dpRecAbortController;

    fetch('/search?view=cart-recs&type=product&q=' + encodeURIComponent(query), {
      credentials: 'same-origin',
      signal: thisController.signal
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* Hvis controller blev erstattet/abortet siden vi startede, drop denne respons */
        if (dpRecAbortController !== thisController) return;
        var trimmed = (html || '').trim();
        if (!trimmed) { dpRecLoading = false; return; }

        if (labelEl) {
          var key = isRecent ? 'data-empty-rec-label-recent' : 'data-empty-rec-label-fallback';
          var labelText = recArea.getAttribute(key);
          if (labelText) labelEl.textContent = labelText;
        }

        /* DEFENSIV: clear non-h3 børn lige før injection - selv hvis reset() blev
           sprunget over eller en stale fetch ville inject'e oven på allerede injicerede. */
        clearEmptyCartCards(recArea);
        recArea.insertAdjacentHTML('beforeend', trimmed);

        /* HÅRD CAP 2: hvis noget skulle smutte gennem (template ændret, race, etc.)
           sørg for at præcis 2 UpsellCards (+ deres templates) vises. */
        var cards = recArea.querySelectorAll('.UpsellCard');
        if (cards.length > 2) {
          for (var i = 2; i < cards.length; i++) cards[i].remove();
        }
        var templates = recArea.querySelectorAll('template[id^="quick-add-template-"]');
        if (templates.length > 2) {
          for (var j = 2; j < templates.length; j++) templates[j].remove();
        }

        recArea.style.display = '';
        dpRecLoading = false;
      })
      .catch(function (e) {
        dpRecLoading = false;
        /* AbortError er forventet ved reset, ignorér silent */
      });
  }

  /* ---------- init ---------- */

  /* Observer drawer aria-hidden så vi refresher recently-viewed på HVER åbning
     (frisk localStorage-read, aldrig cached snapshot). Debounce: flere mutations
     i samme batch -> kun ét reset+load. */
  function attachDrawerOpenObserver() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer || drawer.__dpObserverAttached) return;
    drawer.__dpObserverAttached = true;
    var lastTrigger = 0;
    new MutationObserver(function (mutations) {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      var now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : 0;
      /* Debounce 300ms - undgår at flere aria-hidden mutations samme batch fyrer flere loads */
      if (now - lastTrigger < 300) return;
      lastTrigger = now;
      resetEmptyCartRecentlyViewed();
      loadEmptyCartRecentlyViewed();
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    attachCheckoutInterceptors();
    attachDrawerOpenObserver();
    sikrUpsellFroe().then(synkUpsellVist);
    /* Bemærk: NO loadEmptyCartRecentlyViewed() her - drawer er hidden ved
       page-load, så hverken brugeren ser noget eller har behov for cards endnu.
       Observer henter friske data ved første drawer-open. Det fjerner også
       race: tidlig init-fetch der kommer for sent og inject'er oven på en
       observer-trigget fetch. */
  }

  /* Re-attach på cart:refresh fordi cart-drawer indhold swappes */
  document.documentElement.addEventListener('cart:refresh', function () {
    /* Vent på at refresh-fetch + DOM-swap er færdige */
    setTimeout(function () {
      refreshCartData().then(function () {
        attachCheckoutInterceptors();
        attachDrawerOpenObserver();
        /* Cart-state kan have ændret sig (e.g. add fra tom kurv -> fyldt, eller
           remove sidste vare -> tom). Reset + load henter friske recently-viewed. */
        resetEmptyCartRecentlyViewed();
        loadEmptyCartRecentlyViewed();
        sikrUpsellFroe().then(synkUpsellVist);
      });
    }, 600);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
